<template>
  <div class="invoices">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />
    <InvoicesTable @create-invoice="onCreateInvoice" @edit-invoice="onEditInvoice" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import InvoicesTable from '@/components/Invoices/InvoicesTable';

export default {
  name: 'Invoices',
  components: {
    Breadcrumbs,
    InvoicesTable,
  },
  computed: {
    breadcrumbs() {
      return [{ name: 'Home', route: { name: 'home' } }, { name: this.$t('invoices') }];
    },
  },
  methods: {
    onCreateInvoice() {
      this.$router.push({ name: 'InvoiceCreatePage' });
    },
    onEditInvoice(invoice) {
      this.$router.push({
        name: 'InvoiceEditPage',
        params: { invoiceNumber: invoice.number },
      });
    },
  },
};
</script>

<style lang="scss"></style>
